// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.landing {
    position: fixed;
}
#map {
    position: fixed;
    left: 0;
    right: 0;
    /* width: 67vw; */
    margin-left: auto;
    margin-right: auto;
    z-index: -1;
}`, "",{"version":3,"sources":["webpack://./src/styles/pages/Landing.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;AACA;IACI,eAAe;IACf,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf","sourcesContent":[".landing {\n    position: fixed;\n}\n#map {\n    position: fixed;\n    left: 0;\n    right: 0;\n    /* width: 67vw; */\n    margin-left: auto;\n    margin-right: auto;\n    z-index: -1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
